import { authFetch } from '../../utils/authFetch';

import {
  RESET_CONFIG_STATE,
  FETCH_CONFIG_START,
  FETCH_CONFIG_SUCCESS, 
  FETCH_CONFIG_FAILURE, 
  FETCH_ALL_CONFIGS_START,
  FETCH_ALL_CONFIGS_SUCCESS,
  FETCH_ALL_CONFIGS_FAILURE, 
  SAVE_CONFIG_START, 
  SAVE_CONFIG_SUCCESS, 
  SAVE_CONFIG_FAILURE,
  CONFIG_UPDATE_SUCCESS,
  CONFIG_UPDATE_FAILURE }from './actionTypes.js'

// Fetch a single configuration

export const resetConfigState = () => ({
  type: RESET_CONFIG_STATE
});
export const fetchConfigStart = () => ({
  type: FETCH_CONFIG_START,
});

export const fetchConfigSuccess = (name, data) => ({
  type: FETCH_CONFIG_SUCCESS,
  payload: { name, data },
});

export const fetchConfigFailure = (error) => ({
  type: FETCH_CONFIG_FAILURE,
  payload: error,
});

// Fetch all configuration names
export const fetchAllConfigsStart = () => ({
  type: FETCH_ALL_CONFIGS_START,
});

export const fetchAllConfigsSuccess = (configNames) => ({
  type: FETCH_ALL_CONFIGS_SUCCESS,
  payload: configNames,
});

export const fetchAllConfigsFailure = (error) => ({
  type: FETCH_ALL_CONFIGS_FAILURE,
  payload: error,
});

// Save a configuration
export const saveConfigStart = () => ({
  type: SAVE_CONFIG_START,
});

export const saveConfigSuccess = (name, data) => ({
  type: SAVE_CONFIG_SUCCESS,
  payload: { name, data },
});

export const saveConfigFailure = (error) => ({
  type: SAVE_CONFIG_FAILURE,
  payload: error,
});

// Thunk to fetch a single configuration
export const fetchConfig = (name) => async (dispatch, getState) => {
    const { config } = getState();
    
    // Prevent fetching if already loading or already fetched
    if (config.configs[name]) {
      return;
    }
  
    dispatch(fetchConfigStart(name));
    try {
      const response = await authFetch('/.netlify/functions/getConfig', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name }),
      });
  
      if (!response.ok) {
        throw new Error(`Failed to fetch configuration: ${response.statusText}`);
      }
  
      const data = await response.json();
      dispatch(fetchConfigSuccess(name, data));
    } catch (error) {
      console.error('Error fetching configuration:', error);
      dispatch(fetchConfigFailure(name, error.message));
    }
  };

// Thunk to fetch all configuration names
export const fetchAllConfigs = () => async (dispatch) => {
  dispatch(fetchAllConfigsStart());
  try {
    const response = await authFetch('/.netlify/functions/listConfigs', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch configurations: ${response.statusText}`);
    }

    const data = await response.json();
    dispatch(fetchAllConfigsSuccess(data.configNames)); // Assume backend returns { configNames: ['contextForm', ...] }
  } catch (error) {
    console.error('Error fetching all configurations:', error);
    dispatch(fetchAllConfigsFailure(error.message));
  }
};


export const saveConfig = (name, data) => async (dispatch) => {
  dispatch(saveConfigStart());
  try {
    // 1) persist to DB
    const saveRes = await authFetch('/.netlify/functions/saveConfig', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, data }),
    });
    const saveBody = await saveRes.json();
    if (!saveRes.ok) {
      throw new Error(saveBody.error || saveBody.message || 'Save failed');
    }

    // 2) optimistic update in Redux
    dispatch(saveConfigSuccess(name, data));
    dispatch(configUpdateSuccess(name, data));

    // 3) then re-fetch the canonical version from the DB
    const fetchRes = await authFetch('/.netlify/functions/getConfig', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name }),
    });
    if (!fetchRes.ok) {
      throw new Error(`Reload failed: ${fetchRes.statusText}`);
    }
    const freshData = await fetchRes.json();
    dispatch(fetchConfigSuccess(name, freshData));

  } catch (error) {
    console.error('Error in saveConfig thunk:', error);
    dispatch(saveConfigFailure(error.message));
    dispatch(configUpdateFailure(name, error.message));

    // if the reload itself fails, we can also notify via fetchConfigFailure
    dispatch(fetchConfigFailure(error.message));
  }
};

export const configUpdateSuccess = (name, data) => ({
  type: CONFIG_UPDATE_SUCCESS,
  payload: { name, data },
});

export const configUpdateFailure = (name, error) => ({
  type: CONFIG_UPDATE_FAILURE,
  payload: { name, error },
});